<template>
  <header :class="{ 'page-header': true, 'page-header-collapsed': collapsed }">
    <div class="page-title-wrapper">
      <h1 class="page-title">{{ $route.meta.title }}</h1>
    </div>
  </header>
</template>

<script>
export default {
  name: "LtiHeader",
  props: ["collapsed"],
  data() {
    return {};
  },
};
</script>
